<template>
  <div class="pagination-box">
    <ul  class="pagination">
      <li :class="{'disabled': current == 1}" class="arrowBtn"><a href="javascript:;" @click="setCurrent(current - 1)"> « </a></li>
      <li :class="{'disabled': current == 1}" class="fontBtn"><a href="javascript:;" @click="setCurrent(1)"> 首页 </a></li>
      <li v-for="(p,index) in grouplist" :class="{'active': current == p.val,'omit':p.text=='...'}" :key="index"><a href="javascript:;" @click="setCurrent(p.val)"> {{ p.text }} </a> </li>
      <li :class="{'disabled': current == page}" class="fontBtn"><a href="javascript:;" @click="setCurrent(page)"> 尾页 </a></li>
      <li :class="{'disabled': current == page}"  class="arrowBtn"><a href="javascript:;" @click="setCurrent(current + 1)"> »</a></li>
    </ul>
  </div>
</template>

<script type="es6">
  export default{
    data(){
      return {
       current: this.pagingparam.params.pageNo,

      }
    },
    props: {
      pagingparam:{
        type:Object
      },
      pagegroup: {// 分页条数
        type: Number,
        default: 5,
        coerce: function (v) {
          v = v > 0 ? v : 5;
          return v % 2 === 1 ? v : v + 1;
        }
      }
    },
    computed: {
      display:function() {// 每页显示条数
        return this.pagingparam.params.pageSize;
      },
      page: function () { // 总页数
       return  Math.ceil(this.pagingparam.total / this.display);
      },
      grouplist: function () { // 获取分页页码
        var len = this.page, temp = [], list = [], count = Math.floor(this.pagegroup / 2), center = this.current;
        if (len <= this.pagegroup) {
          while (len--) {
            temp.push({text: this.page - len, val: this.page - len});
          }
          ;
          return temp;
        }
        while (len--) {
          temp.push(this.page - len);
        }
        ;
        var idx = temp.indexOf(center);
        (idx < count) && ( center = center + count - idx);
        (this.current > this.page - count) && ( center = this.page - count);
        temp = temp.splice(center - count - 1, this.pagegroup);
        do {
          var t = temp.shift();
          list.push({
            text: t,
            val: t
          });
        } while (temp.length);
        if (this.page > this.pagegroup) {
          (this.current > count + 1) && list.unshift({text: '...', val: list[0].val - 1});
          (this.current < this.page - count) && list.push({text: '...', val: list[list.length - 1].val + 1});
        }
        console.log(list)
        return list;
      }
    },
    methods: {
      setCurrent(idx){
        if (this.current != idx && idx > 0 && idx < this.page + 1) {
             this.current = idx;
            let param={
              pageSize: this.display,
              pageNo: this.current
            };
            this.$get(this.pagingparam.url, param).then((res) => {
              console.log('this is'+this.current+'数据');
              this.$emit('pageData', res.data);            
            }).catch((err) => {
              console.log(err)
            })
             
        }
         
      }
    }
  }
</script>

<style lang="scss">
.pagination-box{
  width: 1200px;
  height: 50px;
  float:left;
  .pagination {
    overflow: hidden;
    display: table;
    margin: 0 auto;
    height: 50px;

  li {
    float: left;
    height: 30px;
    border-radius: 50%;
    margin: 3px;
    color: #666;

  &
  :hover {
    background: #AE954F;

  a {
    color: #fff;
  }

  }
  a {
    display: block;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    font-size: 12px;
    color: #fff;
    border-radius: 50%;
    background: #003478;
    text-decoration: none
  }

  }
  .active {
    a {
      color: #fff;
      background: #AE954F;
    }
  }
  li.arrowBtn{
    width: 30px;
    height:30px;
    text-align: center;
    font-size: 20px;
    border-radius: 50%;
    background:rgba(0,52,120,1);
    a{
      font-size: 20px;
      color: #ffffff;
      line-height: 25px;
    }
  }
  li.omit{
    a{
      line-height: 25px;
    }
  }
   li.fontBtn{
      a{
        background: none;
        color:#333;
      }
   }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pagination/pagination.vue